const Main = () => import('@/components/Main')
// const Index = () => import('@/views/kanban/Index.vue')
const Project = () => import('@/views/kanban/Project.vue')
const Project2 = () => import('@/views/kanban/Project2.vue')
const sspProject = () => import('@/views/kanban/project/sspPage.vue')
const Business = () => import('@/views/kanban/Business.vue')
const Liuliang = () => import('@/views/kanban/custom/liuliang.vue')
const yingshou = () => import('@/views/kanban/custom/yingshou.vue')
const power = () => import('@/views/kanban/custom/power.vue')
// const ShareScreen = () => import('@/views/kanban/ShareScreen.vue')
// const MediaFinancial = () => import('@/views/kanban/MediaFinancial.vue')
// const Parlor = () => import('@/views/kanban/Parlor.vue')
// const DigitalMarketing = () => import('@/views/kanban/DigitalMarketing.vue')
const SelectMonth = () => import('@/views/kanban/SelectMonth.vue')
const closedLoopRate = () => import('@/views/kanban/ClosedLoopRate.vue')
const KanbanConfigView = () => import('@/views/kanban/KanbanConfigView.vue')
const KanbanConfigViewV3 = () => import('@/views/kanban/KanbanConfigViewV3.vue')
const Login = () => import('@/views/Login')
const applyAuthority = () => import('@/views/applyAuthority')
const noAuthority = () => import('@/views/noAuthority')
// const ChinaMapTerimal = () => import('@/views/ChinaMapTerimal/ChinaMapTerimal')
const Finance = () => import('@/views/kanban/Finance.vue')
const Quality = () => import('@/views/kanban/Quality.vue')
const TtcIframe = () => import('@/views/ttcIframe/ttcIframe.vue')
//

const retrieval = () => import('@/views/kanban/retrieval.vue')

const children = [
  {
    name: 'index',
    path: '/',
    components: {
      default: () => import('@/views/kanban/Index/Index-3.2.4'),
      v32: () => import('@/views/kanban/Index/Index-3.2.vue'),
      v324: () => import('@/views/kanban/Index/Index-3.2.4')
    },
    meta: {
      title: '经营看板',
      tab: '酷开主页'
    }
  },
  {
    name: 'Project',
    path: '/Project',
    component: Project,
    meta: {
      title: '智能分人群运营-尝鲜版面效果改善',
      hideInMenu: true
    }
  },

  {
    name: 'Project2',
    path: '/Project2',
    component: Project2,
    meta: {
      title: '智能海报',
      hideInMenu: true
    }
  },
  {
    name: 'ssp-project',
    path: '/ssp-project',
    component: sspProject,
    meta: {
      title: '广东省网SSP项目数据看板',
      hideInMenu: true
    }
  },
  {
    name: 'business-kanban',
    path: '/business',
    component: Business,
    meta: {
      title: '客厅事业部核心业务指标增长看板',
      tab: '客厅事业部',
      hideInMenu: true
    }
  },
  {
    name: 'liuliang-kanban',
    path: '/custom/liuliang',
    component: Liuliang,
    meta: {
      title: '流量看板',
      tab: '客厅事业部',
      hideInMenu: true
    }
  },
  {
    name: 'liuliang-kanban',
    path: '/custom/yingshou',
    component: yingshou,
    meta: {
      title: '营收看板',
      tab: '客厅事业部',
      hideInMenu: true
    }
  },
  {
    name: 'liuliang-kanban',
    path: '/custom/power',
    component: power,
    meta: {
      title: '竞争力看板',
      tab: '客厅事业部',
      hideInMenu: true
    }
  },
  {
    name: 'Parlor',
    path: '/parlor',
    components: {
      default: () => import('@/views/kanban/Parlor/Parlor-3.2.4.vue'),
      v32: () => import('@/views/kanban/Parlor'),
      v324: () => import('@/views/kanban/Parlor/Parlor-3.2.4.vue')
    },
    meta: {
      title: '经营看板-大内容',
      tab: '大内容事业部'
    }
  },
  // {
  //   name: 'Parlor-3.2.4',
  //   path: '/parlor324',
  //   component: () => import('@/views/kanban/Parlor/Parlor-3.2.4'),
  //   meta: {
  //     title: 'Parlor-3.2.4',
  //     tab: 'Parlor-3.2.4'
  //   }
  // },
  {
    name: 'DigitalMarketing',
    path: '/digital-marketing',
    // component: DigitalMarketing,
    meta: {
      title: '经营看板-数字营销',
      tab: '数字营销事业部'
    },
    // component: () => import('@/views/kanban/DigitalMarketing/DigitalMarketing-3.4.vue')
    components: {
      default: () => import('@/views/kanban/DigitalMarketing/DigitalMarketing-3.4.vue'),
      v32: () => import('@/views/kanban/DigitalMarketing/DigitalMarketing-3.0.vue'),
      v324: () => import('@/views/kanban/DigitalMarketing/DigitalMarketing-3.0.vue')
    }
  },

  {
    name: 'closed-loop-rate',
    path: 'closed-loop-rate/',
    component: closedLoopRate,
    meta: {
      title: 'dynamic',
      hideInMenu: true
    }
  },
  // {
  //   name: 'MediaFinancial',
  //   path: '/media-financial',
  //   component: MediaFinancial,
  //   meta: {
  //     title: '融媒体事业部业务增长看板',
  //     tab: '融媒体事业部'
  //   }
  // },
  {
    name: 'SystemDevelopmentDivision',
    path: '/System-development-division',
    components: {
      default: () => import('@/views/kanban/SystemDevelopmentDivision/SystemDevelopmentDivision.vue'),
      v32: () => import('@/views/kanban/MediaFinancial.vue'),
      v324: () => import('@/views/kanban/MediaFinancial.vue')
    },
    meta: {
      title: '经营看板-系统拓展',
      tab: '系统拓展事业部'
    }
  },
  {
    name: 'ResearchDevelopmentBulletinBoard',
    path: '/RDBoard',
    component: () => import('@/views/kanban/ResearchDevelopmentBulletinBoard/ResearchDevelopmentBulletinBoard-3.8'),
    meta: {
      title: '系统技术中心',
      tab: '系统技术中心',
      hideInMenu: true
    }
  },
  {
    name: 'IframeWrap',
    path: '/kanbanconfig',
    props: true,
    component: () => import('@/views/IframeWrap/IframeWrap'),
    meta: {
      title: 'Coolita事业部',
      tab: 'Coolita事业部',
      id: 114
    }
  },
  {
    name: 'InvestManageDepart',
    path: '/InvestManageDepart',
    props: true,
    component: () => import('@/views/InvestManageDepart/index'),
    meta: {
      title: '投资管理部',
      tab: '投资管理部'
    }
  },
  // {
  //   name: 'Finance',
  //   path: '/finance',
  //   component: Finance,
  //   meta: {
  //     title: '财务经营业绩',
  //     tab: '财务经营业绩'
  //     // bodyHeight: 'auto'
  //   }
  // },
  {
    name: 'Quality',
    path: '/quality',
    component: Quality,
    meta: {
      // title: '(香港)财务经营看板',
      // tab: '(香港)财务经营看板'
      title: '财务经营业绩',
      tab: '财务经营业绩'
      // bodyHeight: 'auto'
    }
  }

  //
  // {
  //   name: 'share-screen',
  //   path: '/share-screen',
  //   component: ShareScreen,
  //   meta: {
  //     title: '共享屏事业部业务增长看板',
  //     tab: '共享屏事业部'
  //   }
  // }
]

const routes = [
  // {
  //   path: '/',
  //   component: Main,
  //   children
  // },
  {
    path: '/',
    component: TtcIframe,
    children
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('@/views/mobile/kanban/index'),
    children: [
      {
        path: '/mobile-lists',
        name: 'mobile-lists',
        component: () => import('@/views/mobile/kanbanPersonal/kanbanPersonal'),
        meta: {
          title: '登录',
          loginType: true
        }
      }
    ]
  },
  {
    path: '/realTimeKanban',
    name: 'realTimeKanban',
    component: () => import('@/views/boardFrame/realTimeKanban.vue'),
    meta: {
      title: '实时看板',
      tab: '实时看板',
      loginType: false,
      showSelectDate: false
    }
  },
  {
    path: '/CoreCompetitiveness',
    component: () => import('@/views/corecompetitiveness/CoreCompetitiveness'),
    meta: {
      title: '核心竞争力',
      tab: '核心竞争力',
      loginType: false,
      showSelectDate: false
    }
  },
  {
    path: '/DataIndicatorKanban',
    component: () => import('@/views/DataIndicatorKanban/DataIndicatorKanban'),
    meta: {
      title: '数据指标看板',
      tab: '数据指标看板',
      loginType: false,
      showSelectDate: false
    }
  },
  {
    path: '/commonHeader',
    name: 'commonHeader',
    component: () => import('@/views/kanban/commonHeader/commonHeader.vue'),
    props: (route) => {
      return { name: route.query.name }
    },
    children: [
      {
        path: '/ChinaMapTerimal',
        name: 'ChinaMapTerimal',
        component: () => import('@/views/kanban/ChinaMapTerimal/ChinaMapTerimal'),
        props: (route) => {
          return { name: route.query.name }
        }
      }
      // {
      //   name: 'Finance',
      //   path: '/finance',
      //   component: Finance,
      //   meta: {
      //     title: '财务预算',
      //     tab: '财务预算',
      //     bodyHeight: 'auto'
      //   }
      // }
    ]
  },
  {
    name: 'SystemDevelopmentDivisionTerimel',
    path: '/SystemDevelopmentDivisionTerimel',
    component: () => import('@/views/kanban/SystemDevelopmentDivisionTerimel/SystemDevelopmentDivisionTerimel.vue')
  },
  {
    name: 'FinancialMediaIntelligent',
    path: '/FinancialMediaIntelligent',
    component: () => import('@/views/kanban/FinancialMediaIntelligent/FinancialMediaIntelligent.vue')
  },
  {
    name: 'CoolSuperScreen',
    path: '/CoolSuperScreen',
    component: () => import('@/views/kanban/CoolSuperScreen/CoolSuperScreen.vue'),
    meta: {
      loginType: true,
      title: '无界大屏'
    }
  },
  {
    name: 'BSC',
    path: '/BSC',
    component: () => import('@/views/kanban/BSC/BSC.vue'),
    meta: {
      loginType: true,
      title: 'BSC'
    }
  },
  {
    name: 'BSC-new',
    path: '/BSCk',
    component: () => import('@/views/BSC/index.vue'),
    meta: {
      loginType: true,
      title: 'BSCk'
    },
    children: [
      {
        name: 'BSC-home',
        path: '/bindex',
        component: () => import('@/views/BSC/pages/home.vue'),
        meta: {
          loginType: true,
          title: 'BSCk'
        }
      },
      {
        name: 'companyIndicators',
        path: '/bcompanyIndicators',
        component: () => import('@/views/BSC/pages/companyIndicators.vue'),
        meta: {
          loginType: true,
          title: '公司指标'
        }
      },
      {
        name: 'organizationalIndicators',
        path: '/borganizationalIndicators',
        component: () => import('@/views/BSC/pages/organizationalIndicators.vue'),
        meta: {
          loginType: true,
          title: '组织指标'
        }
      },
      {
        name: 'jobIndicators',
        path: '/bjobIndicators',
        component: () => import('@/views/BSC/pages/jobIndicators.vue'),
        meta: {
          loginType: true,
          title: '岗位指标'
        }
      },
      {
        name: 'tastIndicators',
        path: '/btastIndicators',
        component: () => import('@/views/BSC/pages/tastIndicators.vue'),
        meta: {
          loginType: true,
          title: '任务指标'
        }
      },
      {
        name: 'taskEvaluation',
        path: '/btaskEvaluation',
        component: () => import('@/views/BSC/pages/taskEvaluation.vue'),
        meta: {
          loginType: true,
          title: '能力评价'
        }
      },
      {
        name: 'levelHistoryLog',
        path: '/blevelHistoryLog',
        component: () => import('@/views/BSC/pages/levelHistoryLog.vue'),
        meta: {
          loginType: true,
          title: '职称历程'
        }
      },
      /// ////////////////////
      {
        name: 'creatTask',
        path: '/creatTask',
        component: () => import('@/views/BSC/admin/creatTask.vue'),
        meta: {
          loginType: true,
          title: '发布任务'
        }
      },
      {
        name: 'rewardHall',
        path: '/rewardHall',
        component: () => import('@/views/BSC/admin/rewardHall.vue'),
        meta: {
          loginType: true,
          title: '悬赏大厅'
        }
      },
      {
        name: 'budgetCustomization',
        path: '/budgetCustomization',
        component: () => import('@/views/BSC/admin/budgetCustomization.vue'),
        meta: {
          loginType: true,
          title: '预算配置'
        }
      },
      {
        name: 'integralDistribution',
        path: '/integralDistribution',
        component: () => import('@/views/BSC/admin/integralDistribution.vue'),
        meta: {
          loginType: true,
          title: '积分分配'
        }
      },
      {
        name: 'integralCenter',
        path: '/integralCenter',
        component: () => import('@/views/BSC/admin/integralCenter.vue'),
        meta: {
          loginType: true,
          title: '积分中心'
        }
      },
      {
        name: 'X6',
        path: '/X6',
        component: () => import('@/views/BSC/pages/strategicMap.vue'),
        meta: {
          loginType: true,
          title: '战略地图'
        }
      }
    ]
  },
  {
    name: 'Cool9',
    path: '/Cool9',
    component: () => import('@/views/kanban/Cool9/Cool9.vue'),
    meta: {
      title: '酷开9',
      tab: '酷开9',
      hideInMenu: true
    }
  },
  // applyAuthority
  // noAuthority
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      title: '登录',
      loginType: true
    }
  },

  {
    name: 'applyAuthority',
    path: '/apply-authority',
    component: applyAuthority,
    meta: {
      title: '申请权限',
      loginType: true
    }
  },
  {
    name: 'noAuthority',
    path: '/no-authority',
    component: noAuthority,
    meta: {
      title: '无权限提示',
      loginType: true
    }
  },

  {
    name: 'select-month',
    path: '/select-month',
    component: SelectMonth,
    meta: {
      title: '选择月份',
      hideInMenu: true,
      loginType: true
    }
  },
  {
    name: 'kanbanConfigView',
    path: '/kanban-config-view',
    component: KanbanConfigView,
    meta: {
      hideInMenu: true,
      loginType: true,
      title: '项目看板'
    }
  },
  {
    name: 'kanbanConfigViewV3',
    path: '/kanban-config-view-v3',
    component: KanbanConfigViewV3,
    meta: {
      hideInMenu: true,
      loginType: true,
      title: '项目看板'
    }
  },
  {
    name: 'retrieval',
    path: '/retrieval',
    component: retrieval,
    meta: {
      title: '看板检索页',
      hideInMenu: true
    }
  }
]

export default routes
